module.exports = __webpack_public_path__ + "assets/pdf/handbook-cn-webversion-opt.778b07d2.pdf";